import LegalPage from "./LegalPage";

export default function Terms() {
  return (
    <LegalPage
      kicker="Legal"
      title="Terms of Use"
      updated="Feb 2026"
      intro="These terms govern your use of the pfasriskintelligence.co.uk website and the free tools provided on it (the PFAS Risk Triage Tool, the PFAS Risk Checklist download, and the PFAS Risk Watch bulletin signup)."
      sections={[
        { h: "Nature of the service",
          body: [
            "PFAS Risk Intelligence is a desk-based risk intelligence and strategy coordination service. We are not a laboratory, law firm, regulator or remediation contractor. We do not confirm PFAS presence without laboratory testing, and we do not determine legal liability.",
            "The Triage Tool, the Checklist and any commentary on the site are preliminary information tools only. They do not replace accredited laboratory testing, formal contaminated land assessment, legal advice, regulatory approval, expert evidence or remediation design.",
          ] },
        { h: "Acceptable use",
          body: [
            "You agree to use the site only for lawful purposes and to provide accurate information when submitting any form. You agree not to attempt to circumvent security controls, scrape our lead-capture endpoints, or misuse the free downloads.",
          ] },
        { h: "Intellectual property",
          body: [
            "The site content, the PFAS Risk Checklist PDF, the PFAS Risk Triage Tool, PFAS Risk Watch bulletins and all related branding are the intellectual property of PFAS Risk Intelligence. You may share the checklist internally within your organisation for the purpose of assessing your own sites. You may not republish, resell or repackage our content for commercial purposes without prior written consent.",
          ] },
        { h: "Fees and Risk Screens",
          body: [
            "The PFAS Brownfield Risk Screen is a paid service starting from £1,950 + VAT and delivered within 5–7 working days from receipt of the required site information. Nothing on this site constitutes an offer of engagement. A written scope and invoice will be agreed before any Risk Screen work begins.",
          ] },
        { h: "No warranty",
          body: [
            "The free tools on this site are provided on an ‘as is’ basis. To the fullest extent permitted by law, PFAS Risk Intelligence disclaims all warranties, express or implied, in relation to the free tools and the site content.",
          ] },
        { h: "Liability",
          body: [
            "PFAS Risk Intelligence is not liable for decisions made in reliance on the free tools. Users are expected to obtain appropriate specialist investigation, laboratory testing, legal advice and professional contaminated land assessment before making acquisition, planning, construction, remediation, enforcement, insurance, recovery or litigation decisions.",
            "Nothing in these terms excludes or limits liability for death or personal injury caused by negligence, fraud, or any liability which cannot lawfully be excluded.",
          ] },
        { h: "Governing law",
          body: [
            "These terms are governed by the laws of England and Wales and disputes are subject to the exclusive jurisdiction of the courts of England and Wales.",
          ] },
        { h: "Contact",
          body: [
            "Questions about these terms: info@pfasriskintelligence.co.uk.",
          ] },
      ]}
    />
  );
}
